export default "__VITE_ASSET__B41zELC5__"